export default IconDashboardOff => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-dashboard-off" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M11.175 11.178a2 2 0 1 0 2.653 2.634" />
  <path d="M14.5 10.5l1 -1" />
  <path d="M8.621 4.612a9 9 0 0 1 11.721 11.72m-1.516 2.488a9.008 9.008 0 0 1 -1.226 1.18h-11.2a9 9 0 0 1 -.268 -13.87" />
  <path d="M3 3l18 18" />
</svg>`;